export const DEFAULT_UPGRADE_PLAN_SLUG = 'essential';

export const BILLING_POLL_INTERVAL_MS = 4000;

/** Pix e cartão — aguardar confirmação na tela de checkout */
export const BILLING_POLL_MAX_MS = 300000;

/** Boleto pode demorar horas; UX deve orientar sair e voltar depois */
export const BILLING_POLL_MAX_MS_BOLETO = 300000;
